/**
 * The demo persona's member object, shared between handlers. `overrides.ts` builds it and serves it at
 * `GET /members/`; the questionnaire mock returns the same object and merges each submission's
 * `member` payload into it, so both endpoints agree the way the real backend's do. Resets on reload.
 */
type DemoMember = Record<string, unknown>;

let demoMember: DemoMember = {};

export function setDemoMember(member: DemoMember): void {
    demoMember = member;
}

export function getDemoMember(): DemoMember {
    return demoMember;
}
